var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// class definition
import { LitElement } from '@horizon/base';
import { property } from '@horizon/base/decorators.js';
import { unsafeStatic, html } from '@horizon/base/static-html.js';
import dividerStyles from './divider.css.js';
/**
 *
 * @tag hzn-divider
 * @tagname hzn-divider
 * @summary A 1px tall horizontal divider with no padding or margins
 */
export class HznDivider extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Sets the tone for the horizontal divider
         */
        this.tone = 'subdued';
    }
    render() {
        return html `<${unsafeStatic(this.vertical ? 'div' : 'hr')} class="hzn-divider"></${unsafeStatic(this.vertical ? 'div' : 'hr')}>`;
    }
}
HznDivider.styles = [dividerStyles];
__decorate([
    property({ type: String, reflect: true })
], HznDivider.prototype, "tone", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HznDivider.prototype, "vertical", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznDivider.prototype, "on", void 0);
//# sourceMappingURL=divider.js.map